import { IKhoiActions } from "../../action-types/category/IKhoiActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKhoiReducer } from "../../reducer-model/category/IKhoiReducer";

const iniState: IKhoiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    khois: []
};

export const khoiReducer = (state: IKhoiReducer = iniState, action: IKhoiActions): IKhoiReducer => {
    switch (action.type) {
        case "KHOI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "KHOI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                khois: action.payload
            };
        case "KHOI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "KHOI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                khoiEditing: action.payload
            };
        case "KHOI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "KHOI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "KHOI_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            };
        case "KHOI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "KHOI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "KHOI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "KHOI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};
